'use client'

import { ComponentTranslationContext, FilterContext } from '../../../providers'
import { CloseIcon, FilterIcon } from '../../icons'
import React, { ReactElement, useContext } from 'react'
import { Button, ButtonVariants } from '../../atoms'
import { MESSAGE_KEYS } from '../../../constants/messageKeys'

export interface FilterActionsProps extends React.HTMLAttributes<HTMLDivElement> {}

export const FilterActions = ({ ...props }: FilterActionsProps): ReactElement => {
    const { getLabel } = useContext(ComponentTranslationContext)
    const { isExpanded, toggleFilters, clearFilters, hasClearableFilters, isInitialized } = useContext(FilterContext)

    if (!isInitialized) return <></>

    return (
        <div {...props} className={`inline-flex gap-2 ${props.className ?? ''}`}>
            <Button
                variant={ButtonVariants.QUIET}
                icon={<FilterIcon />}
                onClick={() => toggleFilters()}
                data-testid="toggle-filters"
            >
                {isExpanded && getLabel(MESSAGE_KEYS.FILTERS_HIDE)}
                {!isExpanded && getLabel(MESSAGE_KEYS.FILTERS_SHOW)}
            </Button>
            {hasClearableFilters && (
                <Button
                    variant={ButtonVariants.DANGER_QUIET}
                    icon={<CloseIcon />}
                    onClick={() => clearFilters()}
                    data-testid="clear-filters"
                >
                    {getLabel(MESSAGE_KEYS.FILTERS_RESET)}
                </Button>
            )}
        </div>
    )
}
